module.exports = __webpack_public_path__ + "img/Aruba.4e2a06a8.png";